import React from 'react';

import { Capitalize } from 'lib/helpers/utility';

import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import DatePicker from 'components/shared/DatePicker/DatePicker';
import Input from 'components/shared/Input/Input';
import Typography from 'components/shared/Typography/Typography';

import { amountToCents } from '../../../lib/amountToCents';
import { updateProcedureAdjustments } from '../../../lib/updateProcedureAdjustments';

const AdjustmentRow = ({
  insType = 'primary',
  lastAdjustment = {},
  errors = {},
  setErrors = () => {},
  procedureIndex,
  setClaim = () => {}
}) => {
  const isPreviousGroupFilled = (index) => {
    if (index === 0) return true;
    const previous = lastAdjustment?.ins_adj?.[index - 1];
    return previous && (previous?.group || previous?.code) && previous?.amount !== undefined;
  };

  return (
    <>
      <div className="bg-primary-25 px-1">
        <Typography variant="p" className="pb-2" size="small">
          {Capitalize(insType)} Payer Adjustments (ERA/EOP)
        </Typography>
      </div>
      <div className="flex flex-row gap-2 bg-white px-1">
        {Array.from({ length: 4 }).map((_, adjIndex) => {
          const adjustment = lastAdjustment?.ins_adj?.[adjIndex] || {};
          const groupCode = `${adjustment?.group || ''}${adjustment?.code || ''}`;
          const disabled = !isPreviousGroupFilled(adjIndex);

          return (
            <div key={`${insType}-adj-${adjIndex}`} className="flex gap-2">
              <Input
                label="Code"
                value={groupCode}
                disabled={disabled}
                onChange={(e) =>
                  updateProcedureAdjustments({
                    setClaim,
                    procedureIndex,
                    payerType: insType,
                    index: adjIndex,
                    key: 'code',
                    value: e?.target?.value,
                    setErrors
                  })
                }
              />
              <CurrencyInput
                label="Amount"
                id={`${insType}-amount-${adjIndex}`}
                placeholder="Amount"
                disabled={disabled}
                value={amountToCents(adjustment?.amount)}
                onValueChange={(value) =>
                  updateProcedureAdjustments({
                    setClaim,
                    procedureIndex,
                    payerType: insType,
                    index: adjIndex,
                    key: 'amount',
                    value,
                    setErrors
                  })
                }
                parentClassName="!gap-3"
              />
            </div>
          );
        })}
        <DatePicker
          label="Remit Date"
          iconIsRight
          value={lastAdjustment?.paid_date}
          error={errors?.dateError && 'Payment cannot be received before service date'}
          onChange={(value) =>
            updateProcedureAdjustments({
              setClaim,
              procedureIndex,
              payerType: insType,
              key: 'paid_date',
              value,
              setErrors
            })
          }
        />
        <CurrencyInput
          label="Paid"
          id={`${insType}-paid`}
          placeholder="Paid"
          error={errors?.paidError && 'Adjustment paid cannot exceed procedure charge'}
          value={lastAdjustment?.paid}
          onValueChange={(value) =>
            updateProcedureAdjustments({
              setClaim,
              procedureIndex,
              payerType: insType,
              key: 'paid',
              value,
              setErrors
            })
          }
          parentClassName="!gap-3"
        />
      </div>
    </>
  );
};

export default AdjustmentRow;
